<template>
  <div>
    <el-dialog
      ref="addDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h760_dialog abow_dialog"
      width="1200px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogSettingForm"
        :model="dialogSettingForm"
        :rules="dialogSettingFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            调研品规设置
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="4">
                <el-form-item
                  label="省区"
                  prop="provinceId"
                >
                  <el-select
                    v-model="dialogSettingForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item
                  label="城市"
                  prop="cityId"
                >
                  <el-select
                    v-model="dialogSettingForm.cityId"
                    filterable
                    clearable
                    placeholder="请选择城市"
                    style="width:100%"
                    @change="handleCityChange"
                  >
                    <el-option
                      v-for="item in cityOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="24">
                <el-table
                  border
                  size="mini"
                  row-key="id"
                  :data="productDataList"
                  :header-cell-style="{background:'#0076ff'}"
                  class="draggable-table public-table"
                  style="width: 100%; margin:8px 0px;"
                  height="510"
                >
                  <el-table-column
                    label="品规"
                    prop="name"
                    header-align="center"
                    show-overflow-tooltip
                    width="150"
                  />
                  <el-table-column
                    label="排序"
                    prop="serial"
                    align="center"
                    width="60"
                  />
                  <el-table-column
                    label="周报统计"
                    width="90"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-checkbox
                        v-model="scope.row.weekReportView"
                        :true-label="1"
                        :false-label="2"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="月报统计"
                    width="90"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-checkbox
                        v-model="scope.row.monthReportView"
                        :true-label="1"
                        :false-label="2"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最小包库存"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.minPackage"
                        :min="0"
                        :max="99999"
                        :precision="0"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最大包库存"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.maxPackage"
                        :min="0"
                        :max="99999"
                        :precision="0"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最小包价格"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.minPackagePrice"
                        :min="0"
                        :max="99999"
                        :precision="1"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最大包价格"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.maxPackagePrice"
                        :min="0"
                        :max="99999"
                        :precision="1"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最小条价格"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.minStripPrice"
                        :min="0"
                        :max="99999"
                        :precision="1"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最大条价格"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.maxStripPrice"
                        :min="0"
                        :max="99999"
                        :precision="1"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最小集市交易价"
                    width="120"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.minPrice"
                        :min="0"
                        :max="99999"
                        :precision="1"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="最大集市交易价"
                    width="120"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-input-number
                        v-model="scope.row.maxPrice"
                        :min="0"
                        :max="99999"
                        :precision="1"
                        :controls="false"
                        style="width:100%"
                      />
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="状态"
                    width="70"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <el-switch
                        v-model="scope.row.status"
                        active-color="#13ce66"
                        inactive-color="#ff4949"
                        :active-value="1"
                        :inactive-value="2"
                      />
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 表格拖拽
import Sortable from 'sortablejs';
// API
import { listAreaApi } from '@/api/v2/area';
import { listSurveyProductSettingApi, batchUpdateSurveyProductSettingApi } from '@/api/v2/surveyProductSetting';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogSettingForm: {},
      dialogSettingFormRules: {
        provinceId: [{ required: true, message: '请选择省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择城市', trigger: 'change' }],
      },
      provinceOptions: [],
      cityOptions: [],
      // 市场调研品规清单
      productDataList: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this

        _this.dialogSettingForm = {
          provinceId: null,
          cityId: '',
          // 调研品规清单JSON字符串
          productBatchValue: ''
        }
        _this.cityOptions = [];
        _this.productDataList = [];

        // 获取省区选项数据
        _this.loadProvinceData()

        _this.$nextTick(() => {
          _this.initDropSort();
          _this.$refs.dialogSettingForm.clearValidate()
        })
      }
    },
    productDataList: {
      handler: function (newVal) {
        let index = 1;
        newVal.forEach((item) => {
          item.serial = index;
          index++;
        })
      },
      deep: true
    }
  },
  methods: {
    // 初始化Sortable
    initDropSort() {
      let _this = this;
      const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody');
      new Sortable(tbody, {
        draggable: ".el-table__row",
        delay: 0,
        onEnd: ({ newIndex, oldIndex }) => { // 监听拖动结束事件
          //如果位置一样return
          if (newIndex == oldIndex) {
            return;
          }
          const currRow = _this.productDataList.splice(oldIndex, 1)[0]
          _this.productDataList.splice(newIndex, 0, currRow)
        }
      })
    },
    // 获取省区下拉数据
    loadProvinceData() {
      let _this = this;
      _this.provinceOptions = [];
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择省区回调
    handleProvinceChange(val) {
      let _this = this;
      _this.productDataList = [];
      _this.cityOptions = [];
      _this.dialogSettingForm.cityId = '';
      if (val) {
        _this.loadCityData(val);
      }
    },
    // 获取城市选项数据
    loadCityData(provinceId) {
      let _this = this;
      listAreaApi({ parentId: provinceId, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.cityOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择城市回调
    handleCityChange(val) {
      let _this = this;
      _this.productDataList = [];
      if (val) {
        _this.loadSurveyProductData(val);
      }
    },
    // 根据城市ID获取调研品规设置
    loadSurveyProductData(cityId) {
      let _this = this;
      listSurveyProductSettingApi({ cityId: cityId, sortBy: 'status, serial' }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.productDataList.push({
            id: item.id,
            name: item.name,
            // 包库存
            minPackage: item.minPackage || 0,
            maxPackage: item.maxPackage || 0,
            // 包价
            minPackagePrice: item.minPackagePrice || 0,
            maxPackagePrice: item.maxPackagePrice || 0,
            // 条价格
            minStripPrice: item.minStripPrice || 0,
            maxStripPrice: item.maxStripPrice || 0,
            // 集市交易价格
            minPrice: item.minPrice || 0,
            maxPrice: item.maxPrice || 0,
            // 周报是否统计
            weekReportView: item.weekReportView || 0,
            // 月报是否统计
            monthReportView: item.monthReportView || 0,
            // 排序序号
            serial: item.serial || 0,
            status: item.status,
          })
        })
        console.log(_this.productDataList)
      })
    },

    // 新增保存
    handleSave() {
      let _this = this
      if (!_this.productDataList && _this.productDataList.length <= 0) {
        _this.$message.error('没有调研品规设置清单，不能保存')
        return
      }
      _this.$refs.dialogSettingForm.validate(valid => {
        if (valid) {
          _this.dialogSettingForm.productBatchValue = JSON.stringify(_this.productDataList)

          _this.$confirm('是否批量保存调研品规设置', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            batchUpdateSurveyProductSettingApi(_this.dialogSettingForm).then(() => {
              _this.$message({ message: '批量设置成功', type: 'success' })
              _this.$emit('reloadData')
              _this.modalClose()
            }).catch(() => { })
          }).catch(() => { })
        }
      })
    },
    modalClose() {
      let _this = this
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogSettingForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-checkbox-group {
  .el-col {
    min-height: 28px;
    padding: 5px;
  }
}

::v-deep .el-checkbox-button__inner {
  width: 100%;
}
</style>
